<div class="dialog-container">
    <div class="dialog-close">
        <div id="btn-cancel" class="fab small active" (click)="onNoClick()">
            <i class="fas fa-times"></i>
        </div>
    </div>
    <h1 class="condensed dialog-title">Wijzigingshistorie markeringsitem</h1>
    <div class="dialog-content">
        @for (item of history(); track item) {
            <div [innerHTML]="item" class="log-item">
            </div>
        }
        @if (history().length < 1) {
            <div class="log-item">
                Er zijn nog geen wijzigingen
            </div>
        } @else {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
    </div>
</div>

